// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"problem-solved_wrapper__0IQlz"};